/**
 * axios setup to use mock service
 */

import axios from "axios";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { cerrarSesionLocal } from "utils/session";

// const axiosServices = axios.create();
const axiosServices = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_BACKEND_ADDR
      : "http://localhost:8000/",
});

// Toda llamada al backend lleva el ID token de Firebase, como en el resto de
// las plataformas CyDocs. El SDK lo cachea y lo renueva solo antes de que venza.
axiosServices.interceptors.request.use(async (config) => {
  const usuario = firebase.auth().currentUser;
  if (usuario) {
    config.headers.Authorization = `Bearer ${await usuario.getIdToken()}`;
  }
  return config;
});

// interceptor for http
axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    // console.log('axios', error, error.response)
    // Token rechazado por el backend: se cierra la sesión y AuthGuard vuelve
    // al login. Aquí no se puede usar useAuth porque los hooks solo funcionan
    // dentro de componentes.
    if (error.response && error.response.status === 401) {
      cerrarSesionLocal(
        "Tu sesión fue rechazada por el servidor. Vuelve a iniciar sesión."
      );
    }
    return Promise.reject(
      (error.response && error.response.data) || "Wrong Services"
    );
  }
);

export default axiosServices;
